const selectors = {
  marquee: "[data-marquee]",
  container: "[data-marquee-container]",
  group: "[data-marquee-group]",
};

const init = () => {
  Array.from(document.querySelectorAll(selectors.marquee), (marquee) => {
    const duration = Number(marquee.getAttribute("data-marquee-duration")) || 60;
    const container = marquee.querySelector(selectors.container);
    const group = marquee.querySelector(selectors.group);

    const marqueeWidth = marquee.getBoundingClientRect().width;
    const groupWidth = group.getBoundingClientRect().width;

    if (groupWidth === 0) return;
    const count = Math.ceil(marqueeWidth / groupWidth) || 1;

    container.innerHTML = "";

    marquee.style.setProperty("--marquee-duration", duration / count + "s");

    for (let i = 0; i <= count; i++) {
      container.appendChild(group.cloneNode(true));
    }
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
